import { LinkButton } from '@cian/ui-kit';
import { TButtonSize } from '@cian/ui-kit/button/types';
import * as React from 'react';

export interface ICallButtonProps {
  size?: TButtonSize;
  phone: string;
  onClick?(): void;
}

export const CallButton: React.FC<ICallButtonProps> = ({ size = 'L', phone, onClick }) => {
  return (
    <LinkButton size={size} href={`tel:${phone}`} fullWidth onClick={onClick}>
      Позвонить
    </LinkButton>
  );
};
